export default __webpack_public_path__ + "91eb3221c85873fb856995c8791edd66.png";